export default __webpack_public_path__ + "static/Edita_prima_quote_web-b3e059c784a543e3b30ff09623bdb44b.jpg";